import React, { useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import '../../../../styles/css/RelatedConcept.css'
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import { useGetSectionPartysByBookId } from '../../../../hooks/services/sBook/useOfSectionParty'
import SidePanelUsers from './SidePanelUsers';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../../../Templates/List';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { __ListViewMode } from '../../../../common/Dictionaries';
import ToolBar from '../../../../components/Common/Toolbar';
import SidePanelPartySections  from './SidePanelPartySections'
import { createAutomaticListSbSectionPartyMember, createSectionPartyByBookId, deleteSectionPartyById } from '../../../../services/sBook/section-party.service'
import NoDataLayer from '../../../Common/NoDataLayer'
import StatusHeaderItem from '../StatusHeaderItem';
import Message from '../../../Common/Message';
import {saveBook} from "../../../../services/sBook/book.service";
import ListPagination from '../../../Templates/List/ListPagination';
import { useUpdateSectionPartyData } from '../../../../hooks/component/sBook/useOfSectionPartyLinkBox';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { ActionButton, DefaultButton, Dialog, DialogContent, DialogFooter, DialogType, PrimaryButton, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import Loading from '../../../Templates/Site/Loading';

function SectionPartyLinkBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject;
    const inputParam_BookPartyListCounter = props.bookPartyCount;
    const inputParam_BookSectionListCounter = props.bookSectionCount;
    const inputParam_SetterBookSectionPartyList = props.setterBookSectionPartyList;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_SetterFireGetBookUsers = props.setterFireGetBookUsers !== null && props.setterFireGetBookUsers !== undefined ? props.setterFireGetBookUsers : null;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;

    
    const inputParam_SetSectionCardIsSelected = props.setSectionCardIsSelected !== null && props.setSectionCardIsSelected !== undefined ? props.setSectionCardIsSelected : null;
    const inputParam_SectionCardIsSelected = props.sectionCardIsSelected !== null && props.sectionCardIsSelected !== undefined ? props.sectionCardIsSelected : null;

    const inputParam_SelectedSectionCardId = props.selectedSectionCard !== null && props.selectedSectionCard.id !== undefined ? props.selectedSectionCard.id : null;
    const inputParam_StatusFly = props.statusFly !== null && props.statusFly !== undefined ? props.statusFly : null;
    
    const inputParam_BookSectionList = props.bookSectionList !== null && props.bookSectionList !== undefined ? props.bookSectionList : null;
    
    const [message, setMessage] = useState(null);
    const [successful, setSuccessful] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [isUserPanelOpen, setIsUserPanelOpen] = useState(false);
    const [isPartySectionPanelOpen, setIsPartySectionPanelOpen] = useState(false);
    const [tglListViewMode, setTglListViewMode] = useState(__ListViewMode.All);
    
    const [forceUpdate, setForceUpdate] = useState(false);
    const [structureSectionAlertFired, setStructureSectionAlertFired] = useState(false);
    
    const [partyId, setPartyId] = useState(null);
    const [sectionId, setSectionId] = useState(null);
    const [sectionPartyId, setSectionPartyId] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null);

    const [partySectionUserRelationFired, setPartySectionUserRelationFired] = useState(false);

    const [partySectionList, setBookPartySectionList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetSectionPartysByBookId(inputParam_BookObject.id, partySectionList.data, setBookPartySectionList, inputParam_SetterBookSectionPartyList)

    const [filtredSectionArray, setFiltredSectionArray] = useState(partySectionList.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: partySectionList.data.filter(x => x["sectionId"] === inputParam_SelectedSectionCardId), pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: true, data: null });

    useUpdateSectionPartyData(
        partySectionList,
        setBookPartySectionList,
        filtredSectionArray,
        setFiltredSectionArray,
        inputParam_SelectedSectionCardId,
        tglListViewMode,
        inputParam_SectionCardIsSelected,
        inputParam_SetSectionCardIsSelected
    );

    const onDeletePartySection = (sectionPartyItem) => {
        if (sectionPartyItem.id !== 0) {
            deleteSectionPartyById(sectionPartyItem.id).then((response) => {
                if (response.data.succeeded) {
                    setItemToDelete(sectionPartyItem);
                    setShowMessage(true)
                    setSuccessful(true);
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))
                }
                else {
                    setShowMessage(true)
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }); 
        }
        else {
            setItemToDelete(sectionPartyItem);
            setShowMessage(true)
            setSuccessful(true);
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        }
    }

    const onSelectSectionUsers = (sectionPartyId, partyId, sectionId) => {
        setIsUserPanelOpen(true);
        setSectionPartyId(sectionPartyId)
        setPartyId(partyId);
        setSectionId(sectionId);
    }

    const onPreCreateSectionPartyUserRelation = (e) => {
        const data = filtredSectionArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
            (filtredSectionArray.data  !== null ? filtredSectionArray : (partySectionList !== null ? partySectionList : [])) : partySectionList !== null ? partySectionList
        :   [];

        if (data.length > 0 && data.filter(x => x.id > 0).length > 0) {
            setStructureSectionAlertFired(true);
        }
        else {
            onCreateSectionPartyUserRelation();
        }
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        setStructureSectionAlertFired(false);
    };

    const onAcceptCreation = (ev) => {
        ev.preventDefault();
        setStructureSectionAlertFired(false);
        onCreateSectionPartyUserRelation();
    };

    const onCreateSectionPartyUserRelation = () => {
        setPartySectionUserRelationFired(true);
        createAutomaticListSbSectionPartyMember(inputParam_BookObject.id).then((responseList) => {
            console.log('No Err 0');
            if (responseList.data.succeeded) {
                setShowMessage(true)
                setSuccessful(true);
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
    
                setBookPartySectionList({fireUpdate: true, data: responseList.data.data, pageNumber: 1, pageSize: 1000, filters: []});
                console.log('No Err 1');
                inputParam_SetterBookSectionPartyList && inputParam_SetterBookSectionPartyList(responseList.data.data);
                console.log('No Err 2');
                inputParam_SetterFireGetBookUsers && inputParam_SetterFireGetBookUsers(true);
                console.log('No Err 3');
                setPartySectionUserRelationFired(false);
            }
            else {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
                console.log('Err 1');
                setPartySectionUserRelationFired(false);
            }
            console.log('No Err 4');
        }).catch((error) => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
            console.log('Err 2');
            console.log(error)
            setPartySectionUserRelationFired(false);
        });
    }

    const onSaveSectionPartys = (e) => {
        let bookSectionPartyToSave = partySectionList.data.filter(x => x.id <= 0);
        
        if (bookSectionPartyToSave.length > 0) {
            //Guardar elementos partys.
            createSectionPartyByBookId(inputParam_BookObject.id, bookSectionPartyToSave).then((responseList) => {
                //inputParam_BookObject.statusId = 1;
                
                saveBook(inputParam_BookObject).then((response) => {
                    setShowMessage(true)
                    setSuccessful(true);
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))

                    setBookPartySectionList({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []})
                    inputParam_SetterBookSectionPartyList(bookSectionPartyToSave)
                }).catch(() => {
                    setShowMessage(true)
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        } 
    };

    const setSelectedPartySectionList = (_partySectionList) => {
        const newArray = partySectionList.data;

        _partySectionList.forEach(_partySection => {
            let encontrado = false;

            partySectionList.data.forEach(partySection => {
                if (_partySection.sectionId === partySection.sectionId && _partySection.partyId === partySection.partyId) {
                    encontrado = true;
                }
            });

            if (encontrado === false) {
                newArray.push(_partySection);
            }
        });

        setBookPartySectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newArray
        }));
    }

    const onCreateSectionParty = (e) => {
        setIsPartySectionPanelOpen(true);
        setForceUpdate(true);
    };

    const onListViewModeChange = (e, checked) => {
        
        if (!checked) {
            if (inputParam_SelectedSectionCardId === null) {
                setShowMessage(true)
                setSuccessful(true);
                setMessageType("warning");
                setMessage(t('data-lang-msg-selectasection'))
            }
            else {
                setShowMessage(false)
            }
        } else {
            setShowMessage(false)
        }

        setTglListViewMode(checked ? __ListViewMode.All : __ListViewMode.Specific)
        setBookPartySectionList({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
        setFiltredSectionArray({fireUpdate: true, data: null});
        inputParam_SetSectionCardIsSelected && inputParam_SetSectionCardIsSelected(true)
    }

    const updatePartySectionUserCount = (partySectionId, userCount) => {
        
        partySectionList.data.forEach(element => {
            if (element.id === partySectionId) {
                element.userCounts = userCount;
            }
        });


        setBookPartySectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: partySectionList.data
        }));
        
    }

    const toolBarItems_SectionParty  = [
        {
            key: 'relationsectionuser',
            text: t('data-lang-btn-create-section-user-relation'),
            iconProps: { iconName: 'Save' },
            onClick: onPreCreateSectionPartyUserRelation,
        },
        {
            style: { display: partySectionList.data && partySectionList.data.filter(x => x.id <= 0).length > 0 ? "block" : "none" },
            key: 'save',
            text: t('data-lang-btn-save'),
            iconProps: { iconName: 'Save' },
            onClick: onSaveSectionPartys,
        },
        {
            key: 'create',
            text: t('data-lang-btn-add'),
            iconProps: { iconName: 'CircleAddition' },
            onClick: onCreateSectionParty,
        },
    ];

    const displaySectionPartyBox = inputParam_BookObject.id !== null && (inputParam_BookPartyListCounter > 0 && inputParam_BookSectionListCounter > 0)
    
    //#CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newPartySectionArray = [];

        partySectionList.data.forEach(obj => {
            if (obj.id === 0) {
                if (obj.partyId !== itemToDelete.partyId && obj.sectionId !== itemToDelete.sectionId) {
                    newPartySectionArray.push(obj)
                }
            }
            else {
                if (obj.id !== itemToDelete.id) {
                    newPartySectionArray.push(obj)
                }
            }
        })
        inputParam_SetterBookSectionPartyList(newPartySectionArray)

        setBookPartySectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newPartySectionArray
        }));

        setItemToDelete(null);
    }

    return (
    <>
        <Card className='book-user-section-form h-100'>
            <DisabledCard display={ !displaySectionPartyBox } />
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <Row>
                        {
                            inputParam_EditMode === true && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                            <Col className='col-auto ms-auto'>
                                <StatusHeaderItem index={ 5 } statusId={ inputParam_StatusFly } />
                            </Col>
                        }
                        <Col className={ inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) ? "ps-4 ms-3" : "" } >
                            <TooltipHost
                                overflowMode={TooltipOverflowMode.Self}
                                // The TooltipHost itself will overflow
                                content={t('data-lang-boxname-party-section')}
                                onTooltipToggle={false}
                                styles={{
                                    root: { display: 'block' },
                                }}
                                // In this mode, aria-describedby is automatically added/removed based on tooltip visibility
                                >
                                    <div className='d-xs-none d-sm-block d-block d-sm-none' style={{overflow: 'hidden', width: 280, textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}><b>{t('data-lang-boxname-party-section')}</b></div>
                                    <div className='d-xs-none d-sm-block d-none d-sm-block' style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}><b>{t('data-lang-boxname-party-section')}</b></div>
                            </TooltipHost>
                        </Col>
                    </Row>
                </Card.Title>
            </Card.Header>
            <Card.Footer style={{padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <Row className='float-end'>
                    <Col></Col>
                    <Col className='col-auto ms-auto my-auto'>
                        {
                            inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                            <>
                                {
                                    (partySectionUserRelationFired === false) &&
                                    <ToolBar items={ toolBarItems_SectionParty } display={displaySectionPartyBox} />
                                }
                                {
                                    (partySectionUserRelationFired === true) &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="30px"
                                        inputParam_Height="30px"
                                        inputParam_Vertical={false}
                                        inputParam_EjecutingTextClass={"ps-4"}
                                    />
                                }
                            </>
                        }
                    </Col>
                    <Col className='pt-1 me-2 pe-4 col-auto ms-auto' style={{ display: displaySectionPartyBox ? "block" : "none" }}>
                        <Toggle
                            label={""}
                            checked={ tglListViewMode === __ListViewMode.All ? true : false }
                            onChange={ onListViewModeChange }
                            role="checkbox"
                            onText={t('data-lang-lbl-all')}
                            offText={t('data-lang-lbl-section')}
                            styles={ {root:{paddingTop: "9px", marginRight: "-18px", minWidth: "95px", float: "right", display: "flex"}, label: {marginRight : "25px", padding: "0px, 10px"}} }
                        />
                    </Col>
                </Row>
            </Card.Footer>
            <Card.Body style={{ width:"100%" }} className="overflow-auto h-100">
                <Row className='layerBlockedContent'>
                    {
                        partySectionList.data && displaySectionPartyBox === true &&
                        <List
                            manipulateLocalData={ true }
                            listLocalStoragePageSizeVariableName="sectionPartys"
                            className="no-compact-list big-header"
                            data={
                                filtredSectionArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                                    (filtredSectionArray.data  !== null ? filtredSectionArray : (partySectionList !== null ? partySectionList : [])) : partySectionList !== null ? partySectionList
                                :   []
                            }
                            setData={
                                filtredSectionArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                                    (filtredSectionArray.data  !== null ? setFiltredSectionArray : (partySectionList !== null ? setBookPartySectionList : [])) : partySectionList !== null ? setBookPartySectionList
                                :   []
                            }
                            columns={[
                                {  
                                    key: 'sectionName',
                                    name: t('data-lang-lbl-sectionname'),
                                    fieldName: 'sectionName',
                                    minWidth: 400,
                                    maxWidth: 400,
                                },
                                {
                                    key: 'partyName',
                                    name: t('data-lang-lbl-partyname'),
                                    fieldName: 'partyName',
                                    onRender:(item) => {
                                        return <div>{ item.partyName }</div>
                                    }
                                },
                                {
                                    key: 'userCounts',
                                    name: t('data-lang-lbl-usercount'),
                                    fieldName: 'userCounts',
                                    onRender:(item) => {
                                        return <div>{ item.userCounts }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    onRender:(item, row) => {
                                        return  <>
                                                {
                                                    inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                                                    <div>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action float-end"
                                                            role="menubar"
                                                            items={
                                                                item.id !== 0 ?
                                                                [
                                                                    {
                                                                        key: 'item1',
                                                                        icon: 'PeopleAdd',
                                                                        name: t('data-lang-btn-selectusers'),
                                                                        title: t('data-lang-btn-selectusers'),
                                                                        onClick: () => onSelectSectionUsers(item.id, item.partyId, item.sectionId),
                                                                    },
                                                                    {
                                                                        key: 'item2',
                                                                        icon: 'Delete',
                                                                        name: t('data-lang-btn-delete'),
                                                                        title: t('data-lang-btn-delete'),
                                                                        onClick: () => onDeletePartySection(item),
                                                                    }
                                                                ] :
                                                                [
                                                                    {
                                                                        key: 'item2',
                                                                        icon: 'Delete',
                                                                        name: t('data-lang-btn-delete'),
                                                                        title: t('data-lang-btn-delete'),
                                                                        onClick: () => onDeletePartySection(item),
                                                                    }
                                                                ]
                                                            }
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                    </div>
                                                }
                                                
                                                {
                                                    !inputParam_EditMode &&
                                                    <div>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action float-end"
                                                            role="menubar"
                                                            items={
                                                                    [{
                                                                        key: 'item1',
                                                                        icon: 'People',
                                                                        name: t('data-lang-btn-viewusers'),
                                                                        title: t('data-lang-btn-viewusers'),
                                                                        onClick: () => onSelectSectionUsers(item.id, item.partyId, item.sectionId),
                                                                    }]
                                                            }
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                    </div>
                                                }
                                        </>
                                    }
                                }
                            ]}
                        />
                    }
                    <NoDataLayer display={ !displaySectionPartyBox } />
                </Row>
                <SidePanelUsers
                    bookId={ inputParam_BookObject.id }
                    partyId={ partyId }
                    sectionId={ sectionId }
                    sectionPartyId={ sectionPartyId }
                    isPanelOpen={ isUserPanelOpen }
                    setterIsPanelOpen={ setIsUserPanelOpen }
                    setterFireGetBookUsers={ inputParam_SetterFireGetBookUsers  }
                    editMode={inputParam_EditMode}
                    userHasConfigRoleAction={(inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction)}
                    setterUpdateUserCount={ updatePartySectionUserCount }
                />
                <SidePanelPartySections
                    bookId={ inputParam_BookObject.id }
                    isPanelOpen={ isPartySectionPanelOpen }
                    setterIsPanelOpen={ setIsPartySectionPanelOpen }
                    setterSelectedPartySectionItemList={ setSelectedPartySectionList }
                    bookSectionList={ inputParam_BookSectionList }
                    forceUpdate={ forceUpdate }
                    setterForceUpdate={ setForceUpdate }
                    />
            </Card.Body>
            <Card.Footer>
                {
                    partySectionList.data && displaySectionPartyBox &&
                    <>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="sectionPartys"
                            data={
                                filtredSectionArray!== null && tglListViewMode === __ListViewMode.Specific ?
                                    (filtredSectionArray !== null ? filtredSectionArray : (partySectionList !== null ? partySectionList : [])) : partySectionList !== null ? partySectionList
                                :   []
                            }
                            setData={
                                filtredSectionArray!== null && tglListViewMode === __ListViewMode.Specific ?
                                    (filtredSectionArray !== null ? setFiltredSectionArray : (partySectionList !== null ? setBookPartySectionList : [])) : partySectionList !== null ? setBookPartySectionList
                                :   []
                            } />
                    </>
                }
                <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
            </Card.Footer>
        </Card>
        {
            structureSectionAlertFired && 
            <Dialog
                hidden={!structureSectionAlertFired}
                onDismiss={onHideDialog}
                minWidth={800}
                maxWidth={800}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: t('data-lang-boxname-warning'),
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 800 } },
                }}
                >
                <DialogContent>
                    { t('data-lang-msg-partysectionuserwithdata-alertduplicated') }
                </DialogContent>
                <DialogFooter>
                    <Row>
                        <Col className='col-auto ms-auto'>
                            <PrimaryButton onClick={onAcceptCreation} className='mx-1' text={t('data-lang-lbl-yes')} />
                            <DefaultButton onClick={onHideDialog} className='mx-1' text={t('data-lang-lbl-no')} />
                        </Col>
                    </Row>
                </DialogFooter>
            </Dialog>
        }
    </>
    );
}

export default SectionPartyLinkBox;